import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { CredentialsService } from './credentials.service';

/**
 * Pasos que el login deja pendientes y que hay que terminar antes de entrar al resto
 * del sitio: verificar el correo y cambiar la contraseña temporal. Sin esto, con
 * "atrás" o escribiendo la URL se llegaba a /home con la sesión a medias.
 *
 * El backend también los aplica (claims `emailVerificationPending` y
 * `passwordChangeRequired`); aquí solo se evita pintar pantallas que van a fallar.
 */
export const pendingAuthStepGuard: CanActivateFn = () => {
    const credentialsService = inject(CredentialsService);
    const router = inject(Router);
    const credentials = credentialsService.credentials;
    if (!credentials?.accessToken) {
        return true;
    }
    if (credentialsService.getDecodedToken()?.['emailVerificationPending'] === true) {
        return router.createUrlTree(['/verify-email']);
    }
    // El DTO generado lo tipa como string; el backend manda boolean.
    if (String(credentials.isDefaultPassword) === 'true') {
        return router.createUrlTree(['/auth/password-update']);
    }
    return true;
};
